import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/user/getUsers.php';

export default function getUsers({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}